import React from "react";
import PersonCard from "../components/PersonCard";

function People() {
  return (
    <div className="page-container">
      {/* Consistent header image */}
      <img
        src="./people/People_header.png"
        alt="People"
        className="header-img"
      />

      <PersonCard
        image="./people/mazalek.png"
        name="Ali Mazalek"
        role="Professor and Director of the Synlab"
        description="As a Canada Research Chair in Digital Media and Innovation, Professor Mazalek works at the forefront of trends in computing and interaction design that support a tighter integration of the physical and digital worlds. She designs and develops tangible and embodied interaction systems that enable people to be more creative across both science and art disciplines. Her research interests include the design and application of emerging physical sensing and digital media technologies to areas such as narrative expression, abstract thinking, and scientific modeling, as well as the study and use of embodied cognition as a framework for tangible and embodied interaction design. Professor Mazalek received M.S. and Ph.D. degrees from the MIT Media Lab and a Hon. B.Sc. in computer science and mathematics from the University of Toronto."
      />

      <PersonCard
        image="./people/sultana.jpg"
        project="SimSnap"
        projectColor="#ff6600"
        role="Project Lead"
        name="Afroza Sultana"
        description="Afroza Sultana is a postdoc at Synlab, leading the SimSnap project. Her research interests include designing and developing accessible cross-device interactions for various application domains, such as collaborative classroom learning activities and interactive gaming. In the SimSnap project she is applying user-centered design, co-design, and participatory design methods that involve both end users and stakeholders for developing interactive cross-device applications. Her research work, along with the SimSnap team identifies the best-suitable design choices for accessible cross-device touchscreen interfaces. In her doctoral work, she investigated age-related target selection difficulties with touchscreen interaction. She is also interested in designing and developing tangible device interactions for exergames."
      />

      <PersonCard
        image="./people/manshaei.png"
        project="MEMO & MRGeM"
        projectColor="#3399ff"
        role="Project Lead"
        name="Roozbeh Manshaei"
        description="Roozbeh Manshaei is a senior research associate adept in clinical, genomics, and proteomics data analysis. Specializing in modeling biochemical pathways and Next Generation Sequencing (NGS), he navigates vast data complexities using diverse methodologies like linear/nonlinear modeling, network theory, machine learning, and optimization. At Synlab, Roozbeh leads pioneering work in next-generation user interfaces - mixed reality, gestural, tangible, and multi-touch interactions. His ongoing endeavors involve crafting innovative human-machine interfaces to boost productivity in developing interactive visual analytics tools for genomics/clinical data. He also spearheads projects designing computational tools to elevate learning and innovation in biology and medicine. His current focus also extends to a new venture: developing interactive visual analytics tools for migration data."
      />

      <PersonCard
        image="./people/braithwaite.png"
        project="ADAPT"
        projectColor="#009933"
        role="Project Lead"
        name="Finlay Braithwaite"
        description="Finlay Braithwaite is an Assistant Professor of Media Production in The Creative School at Toronto Metropolitan University. He is currently a PhD student in Media and Design Innovation working with Dr. Ali Mazalek at the Synlab. In this research, Finlay is developing new interfaces for variable speed media playback. This work explores the effects, impact, and potential of variable speed speed media playback through the prototyping of new interfaces, both tangible and digital."
      />

      <PersonCard
        image="./people/abuhantash.jpg"
        project="MRGeM"
        projectColor="#9966ff"
        role="Project Lead"
        name="Nour Abu Hantash"
        description="Nour Abu Hantash is a research assistant at Synlab, co-leading the MRGeM project. Her background is in biomedical engineering with a research interest in data analytics tools and data visualizations. She is excited to pursue her graduate studies at Synlab with Dr. Ali Mazalek’s advisory in biomedical engineering with a focus on medical imaging data and their visualization tools."
      />
    </div>
  );
}

export default People;
